export const PREFERRED_LANG_COOKIE = `teyaseer_portal_user_preferred_lang`;
/**
 * We don't clear REMIND_LATER_SURVEY_COOKIE and SKIP_UPDATE_PLOT_LOCATION_COOKIE on logout, because forgerock clear them.
 * If ever Forgerock fix this, then we need to cleear them manually during Logout
 * */
export const REMIND_LATER_SURVEY_COOKIE = `teyaseer.remindSurvey`;
export const SKIP_UPDATE_PLOT_LOCATION_COOKIE = `teyaseer.skipUpdatingPlotLocation`;
export const VENDOR_AUTH_INTENT_KEY = 'vendor_auth_intent';
export const CUSTOMERPORTAL_AUTH_INTENT_KEY = 'customerportal_auth_intent';
export const VENDOR_LOGIN_REDIRECT_COOKIE = 'vendor_login.redirectUrl';
export const VENDOR_TRADE_LICENSE_NUMBER_KEY = 'vendor_registration.tradeLicenseNumber';
export const VENDOR_ACCOUNT_ID_KEY = 'vendor_registration.accountId';
export const VENDOR_CLIENT_ID_KEY = 'vendor_registration.clientId';
export const VENDOR_TRADE_LICENSE_MECS_ELIGIBLE = 'vendor_registration.mecsEligible';

export const VENDOR_CONFIRMATION_STATUS_KEY = 'vendor_confirmation_status';
